const CUnderline = () => {
    return (
        <div className="underline" style={{
            width: '48px',
            height: '4px',
            backgroundColor: '#2962FF',
            borderRadius: '10px',
        }}>
        </div>
    )
}

export default CUnderline;